exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html {\r\n  /*font-family: 'Roboto', sans-serif;*/\r\n}\r\n\r\nbody {\r\n  font-size: 13px;\r\n  font-weight: normal;\r\n  line-height: 20px;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  background-color: #eeeeee;    /* grey200 */\r\n}\r\n\r\nbody, h1, h2, h3, h4, h5, h6 {\r\n  margin: 0;\r\n}\r\n\r\na {\r\n  color: #ff4081;               /* pinkA200 */\r\n  text-decoration: none;\r\n}\r\n\r\ninput[type=number]::-webkit-inner-spin-button,\r\ninput[type=number]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  margin: 0;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]_[local]_[hash:base64:5]!./src/styles/reset.css
// module id = 1169
// module chunks = 1